import useAgentsChats from './useAgentsChats';
import { useSelector } from 'react-redux';
import { selectIsGhostChat } from './agentsChatsReducer';
import { Box, Stack, ButtonBase } from '@mui/material';
import { IconButton, Typography } from '@sweep-io/sweep-design';
import { ArrowLeft, NotePencil } from '@sweep-io/sweep-design/dist/icons';
import ToggleExpandButton from './ToggleExpandButton';
import ClosePanelButton from './ClosePanelButton';

const AgentTopBar = ({ closePanel }: { closePanel?: () => void }) => {
  const { clearActiveAgentClickHandler, activeAgent, startNewChat } = useAgentsChats();
  const isGhostChat = useSelector(selectIsGhostChat);

  if (!activeAgent) {
    return null;
  }
  return (
    <Stack direction="row" justifyContent="space-between" p={1.5}>
      <ButtonBase
        onClick={clearActiveAgentClickHandler}
        sx={{
          justifyContent: 'flex-start',
        }}
      >
        <Box display="flex" gap={1} alignItems="center">
          <IconButton variant="flat" size="tiny">
            <ArrowLeft size="medium" />
          </IconButton>
          <Typography variant="body-medium">{activeAgent.name}</Typography>
        </Box>
      </ButtonBase>
      <Box display="flex" gap={1} alignItems="center">
        {!isGhostChat && (
          <IconButton
            variant="flat"
            onClick={() => {
              if (activeAgent) {
                startNewChat({
                  agentId: activeAgent.id,
                  agentType: activeAgent.type,
                  biEventProps: {
                    origin: 'button',
                    mode: 'collapsed',
                  },
                });
              }
            }}
            size="small"
          >
            <NotePencil />
          </IconButton>
        )}
        <ToggleExpandButton />
        <ClosePanelButton closePanel={closePanel} />
      </Box>
    </Stack>
  );
};

export default AgentTopBar;
